import { ButtonHTMLAttributes, PropsWithChildren, useMemo } from 'react';

import React from 'react';

import { Loader } from 'components/ui/Loader';

import { ChevronSmall } from 'components/svg/ChevronSmall';

import {
    Button as StyledButton,
    ButtonProps as StyledButtonProps,
} from 'styles/button';
import { colors } from 'styles/theme';

interface ButtonProps
    extends PropsWithChildren<
        ButtonHTMLAttributes<HTMLButtonElement> & StyledButtonProps
    > {
    isBackButton?: boolean;
    $isLoading?: boolean;
    $isDisabled?: boolean;
}

export const Button = (props: ButtonProps) => {
    const { children, isBackButton, $isLoading, $isDisabled, $style } = props;

    const childNode = useMemo(
        () => (isBackButton ? <ChevronSmall /> : children),
        [children, isBackButton]
    );

    return (
        <StyledButton
            type="button"
            {...props}
            $isBackButton={isBackButton ?? false}
            $isLoading={$isLoading ?? false}
            $isDisabled={$isDisabled ?? false}
            $style={isBackButton ? 'outline' : $style}
        >
            {!($isLoading ?? false) ? (
                <>{childNode}</>
            ) : (
                <Loader
                    $color={
                        $style == null || $style === 'fill'
                            ? colors.white
                            : colors.grandGreen
                    }
                />
            )}
        </StyledButton>
    );
};
